interface Props {
  title: string;
  lines?: number;
}

const CARD_CLASS =
  'rounded-[12px] border border-[color:var(--nq-line)] bg-[color:var(--nq-surface-card)] px-[18px] py-4 shadow-[inset_0_1px_0_rgba(255,255,255,0.02)]';

const SKELETON = 'block rounded-[4px] bg-white/[0.06] animate-pulse';

const ComparisonCardSkeleton = ({ title, lines = 5 }: Props) => (
  <div className={CARD_CLASS} aria-busy="true">
    <div className="mb-3 flex flex-col">
      <h3 className="text-[1.05rem] font-semibold text-foreground">{title}</h3>
      <div className={`${SKELETON} h-3 w-[min(420px,85%)]`} />
    </div>
    <div className="pb-2 pt-1">
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className={`${SKELETON} mb-2.5 h-3.5`}
          style={{ width: `${88 - i * 7}%` }}
        />
      ))}
    </div>
  </div>
);

export default ComparisonCardSkeleton;
